module.exports = __webpack_public_path__ + "img/1-6.a475ed2e.png";